// src/components/PastCompetitions.jsx
import { Box, Card, CardMedia, CardContent, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { FormattedDate } from "react-intl";
import RevaText from "components/common/RevaText";

export default function PastCompetitions({ competitions = [] }) {
  if (!competitions.length) {
    return (
      <Box sx={{ mt: 4 }}>
        <RevaText variant="h6">No hay competencias finalizadas.</RevaText>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 6 }}>
      <RevaText id="Eventos finalizados" variant="h5" />

      <Grid container spacing={2} sx={{ mt: 1 }}>
        {competitions.map((comp) => (
          <Grid item key={comp.id} xs={12} sm={4} md={3} lg={2}>
            <Link to={`/event/${comp.uuid_}`}>
              <Card
                sx={{
                  backgroundColor: "rgba(255,255,255,0.05)",
                  borderRadius: 2,
                  boxShadow: 3,
                  textDecoration: "none",
                  color: "inherit",
                  height: "100%",
                  transition: "box-shadow 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    boxShadow: 6,
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ height: 140, backgroundColor: "background.main" }}
                  image={comp.full_banner_url}
                  alt={comp.name}
                />
                <CardContent>
                  <RevaText variant="h6">{comp.name}</RevaText>
                  <RevaText variant="body2" color="text.secondary">
                    <FormattedDate value={new Date(comp.start_date)} month="long" day="numeric" />
                    {" - "}
                    <FormattedDate value={new Date(comp.end_date)} year="numeric" month="long" day="numeric" />
                  </RevaText>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
